import { render, staticRenderFns } from "./StrapiTable.vue?vue&type=template&id=8c137afa&scoped=true&"
import script from "./StrapiTable.vue?vue&type=script&lang=js&"
export * from "./StrapiTable.vue?vue&type=script&lang=js&"
import style0 from "./StrapiTable.vue?vue&type=style&index=0&id=8c137afa&lang=scss&scoped=true&"
import style1 from "./StrapiTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c137afa",
  null
  
)

export default component.exports